export default __webpack_public_path__ + "static/media/hivelogo.dbd398c9.png";